// Created by Abhijit for Full page web enquiry form
import HttpClient from "../client/httpclient";
import PaginatedData from "../client/PaginatedData";

import 'regenerator-runtime/runtime';

class OnSiteSearch {
    constructor(DOMelement, openButtonsDOMlist) {
        try {
            this.PageTitle = document.title;
            this.el = DOMelement;
            this.openButtons = openButtonsDOMlist;
            this.method = "GET";
            this.counter = 2;
            this.URL = './on-site-search-card.html?p=';
            this.loadMoreButton = document.getElementById("load__more__results");
            this.loadMoreButton.setAttribute("rel", "next");

            this.itemId;
            this.category = null;
            this.numberOfResultsAfterFiltersApplied;

            this.currentPage = 1;

            this.loadMoreButton.href = window.location.href.toLowerCase();
            this.multipleList = document.getElementById("multiple-list");
            if (this.multipleList !== null) {
                this.filterId = document.getElementById("multiple-list").value.split("%");
                document.getElementById("multiple-list").onchange = function () {
                    this.loadMoreButton = document.getElementById("load__more__results");
                    if (this.loadMoreButton) {
                        this.loadMoreButton.href = window.location.href.toLowerCase();
                    }
                }
            }
            function getParameterByName(name, url = window.location.href.toLowerCase()) {
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }

            var queryStringVal = getParameterByName('page');
            if (queryStringVal == null) {
                var newurl = window.location.href.toLowerCase();
                this.loadMoreButton.href = newurl.toLowerCase() + "?page=2";
            }
            if (this.loadMoreButton) {
                this.URL = this.loadMoreButton.getAttribute("data-action");
                this.totalpage = this.loadMoreButton.getAttribute("data-totalpages");
                this.itemId = this.loadMoreButton.getAttribute("data-item");
            }

            if (queryStringVal && isNumeric(queryStringVal) && queryStringVal != '1') {
                document.querySelector("link[rel='canonical']").href = window.location.href.toLowerCase();

                if (this.counter == this.totalpage) {
                    this.loadMoreButton.style.display = "none";
                    this.loadMoreButton.removeAttribute("href");
                    this.loadMoreButton.removeAttribute("rel");
                }
                else
                    this.loadMoreButton.setAttribute("rel", "next");


                this.counter = parseInt(queryStringVal) + 1;
                if (parseInt(queryStringVal) >= (parseInt(this.totalpage))) {
                    this.loadMoreButton.style.display = "none";
                    this.loadMoreButton.removeAttribute("href");
                    this.loadMoreButton.removeAttribute("rel");
                }
                else
                    this.loadMoreButton.setAttribute("rel", "next");
            }

            if (this.totalpage == 1) {
                this.loadMoreButton.style.display = "none";
                this.loadMoreButton.removeAttribute("href");
                this.loadMoreButton.removeAttribute("rel");
            }

            function isNumeric(str) {
                if (typeof str != "string") return false // we only process strings!  
                return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
            }
            if (process.env.NODE_ENV === "development") {
                this.URL = './src/components/on-site-search/on-site-search-card.html?p=';
            }

            document.addEventListener("click", (event) => {
                if (event.target.classList.contains('tab-header-for-select')) {
                    this.counter = 2;
                    var arrPageTitle = this.PageTitle.split('|');
                    if (arrPageTitle[0].indexOf('Page') >= 0) { arrPageTitle.shift() }
                    document.title = "Page 1 | " + arrPageTitle.join("|");
                }
                if (event.target.classList.contains('sd-filter-dd')) {
                    this.counter = 2;
                    var arrPageTitle = this.PageTitle.split('|');
                    if (arrPageTitle[0].indexOf('Page') >= 0) { arrPageTitle.shift() }
                    document.title = "Page 1 | " + arrPageTitle.join("|");
                }
                if (event.target.id === 'load__more__results') {
                    event.preventDefault();
                    this.loadMoreBlogs();
                    this.updateString();
                }
            })


        } catch (error) {
            console.log(error);
        }
    }

    reformUrl(value) {
        if (value.includes("?")) {
            value = value.replace("?", '');
        }
        var url = window.location.href.toLowerCase();

        if (!url.includes("q=") && !url.includes("t=")) {
            if (!url.includes("page=")) {
                url = url + "?" + value;
            }
        } else {

            if (!url.includes("page=")) {
                url = url + "&" + value;
            }
        }

        var result = url.substring(url.indexOf('?') + 1);
        if (result === url) {
            result = result.split("&");
            result[result.findIndex(element => element.includes("page="))] = value;
            result = result.join('&');
            return result;

        }
        result = result.split("&");
        result[result.findIndex(element => element.includes("page="))] = value;
        result = result.join('&');

        //incase of double '?' from removing filters
        url = url.replace("??","?");

        url = url.split('?');
        url[1] = result;
        url = url.join('?');
        return url;
    }
    updateString = function () {

        if (this.counter < this.totalpage + 1) {

            var url = `?page=${this.counter}`;
            var newurl;

            newurl = this.reformUrl(url);

            document.querySelector("link[rel='canonical']").href = newurl;
            var arrPageTitle = this.PageTitle.split('|');
            if (arrPageTitle[0].indexOf('Page') >= 0) { arrPageTitle.shift() }
            document.title = "Page " + this.counter + " | " + arrPageTitle.join("|");
            window.history.pushState({ path: newurl }, '', newurl);
            url = "?page=" + (parseInt(this.counter) + 1);

            this.loadMoreButton.href = newurl.toLowerCase();

            if ((parseInt(this.counter) + 1) > this.totalpage) {
                this.loadMoreButton.removeAttribute("href");
                this.loadMoreButton.removeAttribute("rel");
            }
            else
                this.loadMoreButton.setAttribute("rel", "next");
        }
    }

    loadMoreBlogs = async () => {
        let data = {
            pageid: this.itemId,
            page: this.counter,
            tab: PaginatedData.getTab(),
            areas: PaginatedData.getSelectedAreas(),
            tags: PaginatedData.getSelectedTags(),
            grades: PaginatedData.getSelectedGrades(),
            themes: PaginatedData.getSelectedThemes(),
            levels: PaginatedData.getSelectedLevels(),
            durations: PaginatedData.getSelectedDurations(),
            familys: PaginatedData.getSelectedFamilys(),
            activityLevels: PaginatedData.getSelectedActivityLevels(),
            Destinations: PaginatedData.getSelectedDestinations(),
            filter: PaginatedData.getFilter(),

            q: PaginatedData.getURLqueryString(),
            category: PaginatedData.getOnsiteSearchCategory(),

        }
        let URLAJAX = `${this.URL}?data=${encodeURI(JSON.stringify(data))}`;
        if (this.counter < this.totalpage + 1) {
            const url = `${URLAJAX}&page=${this.counter}`;
            await HttpClient.AsyncGetRequest(url, this.method)
                .then(card => {

                    let resultData = JSON.parse(card);
                    if (resultData.filterOptions!== undefined)
                        this.filterOptions = JSON.parse(resultData.filterOptions);
                    this.numberOfResultsAfterFiltersApplied = resultData.totalresults;

                    // resets the filter checkboxes to ensure they only match what the current tab contains
                    let paginationData = document.querySelector("#result-page-tab1");
                    paginationData.innerHTML = "";
                    paginationData.insertAdjacentHTML("beforeend", resultData.result);

                    const observer = lozad();
                    observer.observe();

                    if (this.counter == this.totalpage) {
                        this.loadMoreButton.style.display = "none";
                        this.loadMoreButton.removeAttribute("href");
                        this.loadMoreButton.removeAttribute("rel");
                    }
                    else
                        this.loadMoreButton.setAttribute("rel", "next");

                }).catch(error => {
                    console.error(error)
                });
        }
        this.counter = this.counter + 1;
        this.currentPage += 1;

        // Number of results functionality
        if (this.multipleList !== null) {
            const pageNumberOSS = document.createElement("div");
            pageNumberOSS.classList.add("page-number-OSS");
            var totalpage = this.numberOfResultsAfterFiltersApplied
            var currentPageNumber = document.getElementsByClassName("itinerary-list__content__tour-list").length;

            var urlParamsCountry = new URLSearchParams(window.location.search);
            var myParamCountry = urlParamsCountry.get('q');
            var myParamCatagory = urlParamsCountry.get('t') ?? (document.querySelector('.active-select').textContent.replace(/ *\([^)]*\) */g, "").trim().toLocaleLowerCase());

            if (myParamCatagory.slice(-1) === 's') {
                myParamCatagory = myParamCatagory.slice(0, -1);
            }

            let resultsString = totalpage > 1 ? 'results' : 'result';
            pageNumberOSS.innerHTML = `1 - ${currentPageNumber} of ${totalpage} ${myParamCatagory} ${resultsString} for <span style="text-transform: capitalize">"${myParamCountry}"</span>`;
            var child1 = document.querySelector('.itinerary-list__content')
            document.querySelector('.result-page-tab-content').insertBefore(pageNumberOSS, child1);
            var pageNumberOSS1 = pageNumberOSS.cloneNode(true);
            document.querySelector('#result-page-tab1').appendChild(pageNumberOSS1);
            // Number of results functionality
        }

        // Back To Top functionality
        let backToTopButton = document.getElementById("scroll-to-top");

        const footer = document.querySelector('.sd-footer');
        const offsetFromFooter = 20;

        window.addEventListener('scroll', scrollToTopListPage);
        window.addEventListener('touchmove', scrollToTopListPage);

        backToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        function scrollToTopListPage() {

            if (window.scrollY > 100) {
                backToTopButton.classList.add('show');
            } else {
                backToTopButton.classList.remove('show');
            }

            const footerRect = footer.getBoundingClientRect();
            const buttonRect = backToTopButton.getBoundingClientRect();

            if (footerRect.top < window.innerHeight) {
                const newBottom = (window.innerHeight - footerRect.top) + offsetFromFooter;
                backToTopButton.style.bottom = `${newBottom}px`;
            } else {
                backToTopButton.style.bottom = '70px';
            }
        }
        // Back To Top functionality ends


        for (let i = 0; i < document.querySelectorAll('#load__more__results').length - 1; i++) {
            document.querySelectorAll('#load__more__results')[i].style.display = 'none';
        }

        if (document.querySelectorAll('#blog__cards').length > 1) {
            document.querySelectorAll('#blog__cards')[0].style.display = 'none';
        }
        if (currentPageNumber >= totalpage) {
            for (let i = 0; i < document.querySelectorAll('#load__more__results').length; i++) {
                document.querySelectorAll('#load__more__results')[i].style.display = 'none';
            }
        }
    };
}

export default OnSiteSearch;